import React from 'react'
import RatingStars from 'src/widgets/RatingStars/RatingStars'

export default function CafeteriaStaffTemplate({
  viewOnly = false,
  ratingData,
  onChange,
  submittedRating,
}) {
  const getTotalRating = () => {
    const {
      punctuality,
      devotion_to_duty,
      team_spirit,
      appearance,
      effective_at_time,
      follows_food_guidelines,
      communication,
      alertness_and_intelligence,
      behaviour_with_colleagues,
      attendance_and_time_keeping,
      knowledge_of_work,
    } = ratingData

    let total =
      parseInt(punctuality) +
      parseInt(devotion_to_duty) +
      parseInt(team_spirit) +
      parseInt(appearance) +
      parseInt(effective_at_time) +
      parseInt(follows_food_guidelines) +
      parseInt(communication) +
      parseInt(alertness_and_intelligence) +
      parseInt(behaviour_with_colleagues) +
      parseInt(attendance_and_time_keeping) +
      parseInt(knowledge_of_work)
    return total
  }

  const getSubmittedRating = () => {
    const {
      punctuality,
      devotion_to_duty,
      team_spirit,
      appearance,
      effective_at_time,
      follows_food_guidelines,
      communication,
      alertness_and_intelligence,
      behaviour_with_colleagues,
      attendance_and_time_keeping,
      knowledge_of_work,
    } = submittedRating

    let total =
      parseInt(punctuality) +
      parseInt(devotion_to_duty) +
      parseInt(team_spirit) +
      parseInt(appearance) +
      parseInt(effective_at_time) +
      parseInt(follows_food_guidelines) +
      parseInt(communication) +
      parseInt(alertness_and_intelligence) +
      parseInt(behaviour_with_colleagues) +
      parseInt(attendance_and_time_keeping) +
      parseInt(knowledge_of_work)
    return total
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        <table
          width="100%"
          className="table table-striped"
          style={{
            marginTop: '16px',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <tbody>
            <tr>
              <th style={{ width: '70px' }}>Misc. Aspects</th>
              <th style={{ width: '24px' }}>Submitted Rating</th>
              <th style={{ width: '24px' }}>RATING FACTORS</th>
              <th style={{ width: '6px' }}>RATING</th>
            </tr>
            <tr>
              <td>
                <strong>Punctuality</strong>
              </td>
              <td>{submittedRating.punctuality}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.punctuality}
                  onChange={(value) => onChange('punctuality', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.punctuality}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Devotion to Duty</strong>
              </td>
              <td>{submittedRating.devotion_to_duty}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.devotion_to_duty}
                  onChange={(value) => onChange('devotion_to_duty', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.devotion_to_duty}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Team Spirit</strong>
              </td>
              <td>{submittedRating.team_spirit}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.team_spirit}
                  onChange={(value) => onChange('team_spirit', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.team_spirit}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Personal Appearance</strong>
              </td>
              <td>{submittedRating.appearance}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.appearance}
                  onChange={(value) => onChange('appearance', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.appearance}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Effective at Time Management</strong>
              </td>
              <td>{submittedRating.effective_at_time}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.effective_at_time}
                  onChange={(value) => onChange('effective_at_time', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.effective_at_time}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>The Employees Follows Food Guidelines</strong>
              </td>
              <td>{submittedRating.follows_food_guidelines}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.follows_food_guidelines}
                  onChange={(value) => onChange('follows_food_guidelines', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.follows_food_guidelines}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Good at Communication</strong>
              </td>
              <td>{submittedRating.communication}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.communication}
                  onChange={(value) => onChange('communication', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.communication}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Mental Alertness & Intelligence</strong>
              </td>
              <td>{submittedRating.alertness_and_intelligence}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.alertness_and_intelligence}
                  onChange={(value) => onChange('alertness_and_intelligence', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.alertness_and_intelligence}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Behaviour with Colleagues / Employees</strong>
              </td>
              <td>{submittedRating.behaviour_with_colleagues}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.behaviour_with_colleagues}
                  onChange={(value) => onChange('behaviour_with_colleagues', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.behaviour_with_colleagues}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Attendance & Time Keeping</strong>
              </td>
              <td>{submittedRating.attendance_and_time_keeping}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.attendance_and_time_keeping}
                  onChange={(value) => onChange('attendance_and_time_keeping', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.attendance_and_time_keeping}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Knowledge of work</strong>
              </td>
              <td>{submittedRating.knowledge_of_work}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.knowledge_of_work}
                  onChange={(value) => onChange('knowledge_of_work', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.knowledge_of_work}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <b readOnly={viewOnly}>Overall Performance:</b>
              </td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getSubmittedRating()} / 110</td>
              <td></td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getTotalRating()} / 110</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
